export default () => (
  /**
   * Icone de maior que ou menor que para cima.
   * Encontrado por exemplo na tabela de atributos onde
   * tem a função de reordenar a tabela de acordo com o filtro.
   */
  <svg
    width="11"
    height="6"
    viewBox="0 0 11 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.664795 5.07445C0.621045 5.02539 0.587409 4.96818 0.565813 4.90609C0.544218 4.84401 0.535088 4.77827 0.538948 4.71265C0.542807 4.64703 0.55958 4.58282 0.588304 4.5237C0.617029 4.46457 0.65714 4.4117 0.706339 4.36811L5.21108 0.36389C5.30264 0.28243 5.42093 0.237427 5.54348 0.237427C5.66603 0.237427 5.78432 0.28243 5.87588 0.36389L10.3806 4.36811C10.4755 4.4574 10.5318 4.58016 10.5376 4.71031C10.5434 4.84046 10.4982 4.96773 10.4117 5.0651C10.3251 5.16247 10.204 5.22226 10.0741 5.23176C9.94414 5.24127 9.81562 5.19973 9.71582 5.11599L5.54348 1.40749L1.37114 5.11599C1.32205 5.15969 1.26483 5.19328 1.20276 5.21484C1.14068 5.2364 1.07496 5.24551 1.00935 5.24165C0.943751 5.23779 0.879553 5.22104 0.82043 5.19235C0.761307 5.16366 0.708421 5.1236 0.664795 5.07445Z"
      fill="#5E6366"
    />
  </svg>
);
